export enum UserState {
    CONFIRMATION_PENDING = 'CONFIRMATION-PENDING',
    TRIAL = 'TRIAL',
    PAYING = 'PAYING',
}
